import React from 'react'
import { Tooltip } from 'antd' 
import { Button } from 'antd'
import { Space } from 'antd'

import {TT_BGCOLOR } from './constants.js'
import { SIDE_BUTTON_STYLE } from './constants.js'

import sun_icon from './images/sun_icon.png' 
import moon_icon from './images/moon_icon.png' 
import earth_icon from './images/earth_icon.png' 
import mars_icon from './images/mars_icon.png' 
import mercury_icon from './images/mercury_icon.png' 
import venus_icon from './images/venus_icon.png' 
import L1_icon from './images/L1_icon.png'
import { V3DSpace } from './App.js'

class Target_Bar extends React.Component
    {
    constructor (props)
        {
        super (props) 

        this.set_frame_earth = this.set_frame_earth.bind (this) 
        this.set_frame_moon = this.set_frame_moon.bind (this) 
        this.set_frame_sun = this.set_frame_sun.bind (this) 
        this.set_frame_mars = this.set_frame_mars.bind (this) 
        this.set_frame_mercury = this.set_frame_mercury.bind (this) 
        this.set_frame_venus = this.set_frame_venus.bind (this) 
        this.set_frame_L1 = this.set_frame_L1.bind (this)
        }

    set_frame_moon ()
        {
        this.props.set_focus ("MOON")
        }

    set_frame_sun ()
        {
        this.props.set_frame ("SUN")
        }

    set_frame_mars ()
        {
        this.props.set_focus ("MARS")
        }

    set_frame_mercury ()
        {
        this.props.set_focus ("MERCURY")
        }
    set_frame_venus ()
        {
        this.props.set_focus ("VENUS")
        }

    set_frame_earth ()
        {
        this.props.set_frame ("EARTH")
        }

    set_frame_L1 ()
        {
        this.props.set_focus ("L1")
        }

    render ()
        {    
        const filter={filter: "invert(" + this.props.invert.toFixed() + "%)"}

        const earth_button =                    
        <Tooltip    
            placement="right" 
            color={TT_BGCOLOR}
            title="Set the focus to planet Earth.">
            <Button
                size="large"
                type="ghost"
                onClick={this.set_frame_earth} 
                style={SIDE_BUTTON_STYLE}
                >
                <img src={earth_icon} style={filter} className= "icon_image_small" alt="" />
            </Button>
        </Tooltip> ;

        const moon_button =
        <Tooltip    placement="right" 
            color={TT_BGCOLOR}
            title="Set the focus to the Moon.">
            <Button
                size="large"
                type="ghost"
                onClick={this.set_frame_moon} 
                style={SIDE_BUTTON_STYLE}
                >
                <img src={moon_icon} style={filter} className= "icon_image_small" alt="" />
            </Button>
        </Tooltip> ;

        const sun_button =
        <Tooltip    placement="right" 
            color={TT_BGCOLOR}
            title="Set the focus to the Sun.">
            <Button
                size="large"
                type="ghost"
                onClick={this.set_frame_sun} 
                style={SIDE_BUTTON_STYLE}
                >
                <img src={sun_icon} style={filter} className= "icon_image_small" alt="" />
            </Button>
        </Tooltip> ;

        const mercury_button =
        <Tooltip    placement="right" 
            color={TT_BGCOLOR}
            title="Set the focus to planet Mercury.">
            <Button
                size="large"
                type="ghost"
                onClick={this.set_frame_mercury} 
                style={SIDE_BUTTON_STYLE}
                >
                <img src={mercury_icon} style={filter} className= "icon_image_small" alt="" />
            </Button>
        </Tooltip>

        const venus_button = 
        <Tooltip    placement="right" 
            color={TT_BGCOLOR}
            title="Set the focus to planet Venus.">
            <Button
                size="large"
                type="ghost"
                onClick={this.set_frame_venus} 
                style={SIDE_BUTTON_STYLE}
                >
                <img src={venus_icon} style={filter} className= "icon_image_small" alt="" />
            </Button>
        </Tooltip> ;

        const mars_button =
        <Tooltip    placement="right" 
            color={TT_BGCOLOR}
            title="Set the focus to planet Mars.">
            <Button
                size="large"
                type="ghost"
                onClick={this.set_frame_mars} 
                style={SIDE_BUTTON_STYLE}
                >
                <img src={mars_icon} style={filter} className= "icon_image_small" alt="" />
            </Button>
        </Tooltip> ;

        const l1_button =
        <Tooltip    placement="right" 
            color={TT_BGCOLOR}
            title="Set the focus to the Earth/Sun Lagrange Point 1 (L1).">
            <Button
                size="large"
                type="ghost"
                onClick={this.set_frame_L1} 
                style={SIDE_BUTTON_STYLE}
                >
                <img src={L1_icon} style={filter} className= "icon_image_small" alt="" />
            </Button>
        </Tooltip> ;

        return (
            <div className="target_side_bar"> 
                
                    {earth_button}
                    {moon_button}
                    {sun_button}
                    {mercury_button}
                    {venus_button}
                    {mars_button}
                    {l1_button}

            </div>
            ) 
        }
    }

    export default Target_Bar